import { INPUT_TYPE } from '../../components/TableFilter/DynamicInputPicker';

export const ALL_OPTION_ID = 0;

export const ROUND_SPECIAL_FIELD_NAME = {
  DATE_FILTER: 'dateFilter',
  LEAGUES: 'leagues',
  ROUND_ID: 'roundId',
  HIDE_ENDED_ROUNDS: 'hideEndedRounds',
};

export const ROUND_SPECIAL_QUERY_PARAMS_NAME = {
  START_DATE: 'filterStartDate',
  END_DATE: 'filterEndDate',
  LEAGUES: 'filterLeague[]',
  ROUND_ID: 'filterRoundId',
  HIDE_ENDED_ROUNDS: 'filterHideEndedRounds',
};

export const ROUND_SPECIAL_FILTER_FIELD_CONFIGS = function getRoundSpecialFilterConfig (props) {
  return [
    {
      id: 'date-filter',
      type: INPUT_TYPE.DATE_RANGE,
      label: 'Date',
      fieldName: ROUND_SPECIAL_FIELD_NAME.DATE_FILTER,
      initialValue: { from: '', to: '' },
    },
    {
      id: 'leagues',
      type: INPUT_TYPE.MULTI_SELECT,
      label: 'League',
      fieldName: ROUND_SPECIAL_FIELD_NAME.LEAGUES,
      initialValue: [],
      options: props.leagues.map((league) => ({
        id: league.id,
        label: league.name,
      })),
    },
    {
      id: 'roundId',
      type: INPUT_TYPE.INPUT,
      label: 'Round ID',
      fieldName: ROUND_SPECIAL_FIELD_NAME.ROUND_ID,
      initialValue: '',
      inputAttributes: {
        placeholder: '-',
        type: 'number',
        className: 'filter__field-input arrowDisabled',
      },
    },
    {
      id: 'hideEndedRounds',
      type: INPUT_TYPE.CHECKBOX,
      label: 'Hide Ended Rounds',
      fieldName: ROUND_SPECIAL_FIELD_NAME.HIDE_ENDED_ROUNDS,
      initialValue: false,
    },
  ];
};

export const ROUND_SPECIAL_FILTER_LEGENDS = [
  {
    label: 'Ended',
    cssClass: 'ended',
  },
  {
    label: 'In Progress',
    cssClass: 'in-progress',
  },
  {
    label: 'Pre Match',
    cssClass: 'prematch',
  },
  {
    label: 'Skipped',
    cssClass: 'skipped',
  },
];